import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { calendarIcon, categoryIcon, locationIcon, shieldIcon } from 'src/app/app-icons';
import { TrainingLocationModel } from 'src/app/models/training/training-location.model';
import { TrainingSummaryModel } from 'src/app/models/training/training-summary.model';
import { TrainingTypeModel } from 'src/app/models/training/training-type.model';
import { getTrainingLocationLabel } from 'src/app/utils/training-location.utils';
import { getTrainingTypeLabel } from 'src/app/utils/training-type.utils';

@Component({
  selector: 'app-public-training-overview-card',
  standalone: false,
  templateUrl: './public-training-overview-card.component.html',
  styleUrl: './public-training-overview-card.component.scss',
})
export class PublicTrainingOverviewCardComponent {
  @Input({ required: true })
  training!: TrainingSummaryModel;

  constructor(
    private router: Router,
    public translateService: TranslateService,
    private sanitized: DomSanitizer,
  ) {}

  getTypeIcon() {
    return this.sanitized.bypassSecurityTrustHtml(categoryIcon);
  }

  getCalendarIcon() {
    return this.sanitized.bypassSecurityTrustHtml(calendarIcon);
  }

  getLocationIcon() {
    return this.sanitized.bypassSecurityTrustHtml(locationIcon);
  }

  getCategoryIcon() {
    return this.sanitized.bypassSecurityTrustHtml(shieldIcon);
  }

  getTrainingTypeLabel(trainingType: TrainingTypeModel) {
    return getTrainingTypeLabel(trainingType, this.translateService)
  }

  getTrainingLocation(location: TrainingLocationModel) {
    return getTrainingLocationLabel(location);
  }

  openTraining(): void {
    this.router.navigate(['/my-invitation', this.training.key]);
  }

  getTrainingCategoriesLabel(): string | null {
    const categories = this.training.trainingCategories;
    if (!categories?.length) return null;
    return categories.map(c => c.name).join(', ');
  }
}
